import { ApiOutlined, PhoneOutlined } from '@ant-design/icons';
import { Empty } from 'antd';
import { Trans, useTranslation } from 'react-i18next';

const iconStyle = { fontSize: 25 };

export default function EmptyPlugin({ pluginName, pluginId }: { pluginName?: string; pluginId: string }) {
    const { t } = useTranslation('common');

    const icon =
        pluginId === 'com.grispi.call' ? <PhoneOutlined style={iconStyle} /> : <ApiOutlined style={iconStyle} />;

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <Empty description={pluginName} image={icon} imageStyle={{ width: '100%', height: '100%' }}>
                <Trans
                    ns="common"
                    i18nKey="plugin.chat.error"
                    values={{
                        status: null,
                        error: t('plugin.chat.invalidSettings')
                    }}
                >
                    <strong>Error:</strong>
                    <span>status</span>
                    <p>error</p>
                    <p>message</p>
                </Trans>
            </Empty>
        </div>
    );
}
